import PropTypes from "prop-types";
import React from "react";
import HubMultiSelectFilterView from "./HubMultiSelectFilterView";
import { useHubMultiSelectOptions } from "./useHubMultiSelectOptions";

const HubMultiSelectFilter = ({
  hubSelectOptions: externalHubSelectOptions,
  selectedHubIds = [],
  onChange,
  label = "Hub",
  primary = true,
  queryKey = "hub-multi-select",
  queryParams = {},
  isLoading: externalIsLoading,
}) => {
  const shouldFetchHubOptions = externalHubSelectOptions == null;
  const {
    hubSelectOptions: fetchedHubSelectOptions,
    isLoading: isHubOptionsLoading,
  } = useHubMultiSelectOptions({
    queryKey,
    params: queryParams,
    enabled: shouldFetchHubOptions,
  });

  const hubSelectOptions = externalHubSelectOptions ?? fetchedHubSelectOptions;
  const isLoading = externalIsLoading ?? (shouldFetchHubOptions && isHubOptionsLoading);

  return (
    <HubMultiSelectFilterView
      hubSelectOptions={hubSelectOptions}
      selectedHubIds={selectedHubIds}
      onChange={onChange}
      label={label}
      primary={primary}
      isLoading={isLoading}
    />
  );
};

HubMultiSelectFilter.propTypes = {
  hubSelectOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  selectedHubIds: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  primary: PropTypes.bool,
  queryKey: PropTypes.string,
  queryParams: PropTypes.object,
  isLoading: PropTypes.bool,
};

export default HubMultiSelectFilter;
